export const SET_IS_LOADING = 'SELL_ORDERS/SET_IS_LOADING';
export const SET_SELL_ORDERS_LIST = 'SELL_ORDERS/SET_SELL_ORDERS_LIST';
export const SET_SELL_ORDERS_RESUME = 'SELL_ORDERS/SET_SELL_ORDERS_RESUME';
export const SET_SELL_ORDER_MODAL_IS_LOADING = 'SELL_ORDERS/SET_SELL_ORDER_MODAL_IS_LOADING';
export const SET_SELL_ORDER = 'SELL_ORDERS/SET_SELL_ORDER';
export const SET_SELL_ORDER_NF_NUMBER = 'SELL_ORDERS/SET_SELL_ORDER_NF_NUMBER';
export const SET_SELL_ORDER_HAS_NFE = 'SELL_ORDERS/SET_SELL_ORDER_HAS_NFE';
export const CLEAR_SELL_ORDER = 'SELL_ORDERS/CLEAR_SELL_ORDER';